/* Campo popup: delayed reveal; native form submit so Shopify's CAPTCHA
   protection works; on return (?customer_posted=true) reopen in code state.
   Suppressed after signup, and for 7 days after dismissal. */
(function () {
  var KEY_DONE = 'campo_popup_signed_up';
  var KEY_PENDING = 'campo_popup_pending';
  var KEY_DISMISSED = 'campo_popup_dismissed_at';
  var SHOW_DELAY_MS = 3500;
  var DISMISS_DAYS = 7;

  var dialog = document.querySelector('[data-campo-popup]');
  if (!dialog) return;

  function storageGet(k) {
    try { return localStorage.getItem(k); } catch (e) { return null; }
  }
  function storageSet(k, v) {
    try { localStorage.setItem(k, v); } catch (e) { /* private mode */ }
  }
  function storageDel(k) {
    try { localStorage.removeItem(k); } catch (e) { /* private mode */ }
  }

  function showState(name) {
    dialog.querySelectorAll('[data-popup-state]').forEach(function (s) {
      s.hidden = s.dataset.popupState !== name;
    });
  }

  var backdrop = document.createElement('div');
  backdrop.className = 'campo-popup-backdrop';
  backdrop.hidden = true;
  document.body.appendChild(backdrop);

  function openPopup() {
    if (!dialog.open) dialog.show();
    backdrop.hidden = false;
  }

  function close() {
    dialog.close();
    backdrop.hidden = true;
    if (!storageGet(KEY_DONE)) storageSet(KEY_DISMISSED, String(Date.now()));
  }

  backdrop.addEventListener('click', close);

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-campo-popup-open]')) return;
    if (storageGet(KEY_DONE)) { applyDiscount(); showState('code'); } else { showState('join'); }
    openPopup();
  });

  dialog.querySelector('[data-campo-popup-close]').addEventListener('click', close);
  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) close();
  });
  dialog.addEventListener('cancel', function () {
    if (!storageGet(KEY_DONE)) storageSet(KEY_DISMISSED, String(Date.now()));
  });

  function applyDiscount() {
    try { fetch('/discount/FIRSTTRACKS'); } catch (e) { /* non-blocking */ }
  }

  function showCode() {
    storageSet(KEY_DONE, '1');
    applyDiscount();
    showState('code');
  }

  var form = dialog.querySelector('form');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('button[type="submit"]');
      btn.disabled = true;
      fetch(form.action, { method: 'POST', body: new FormData(form) })
        .then(function (r) {
          if (r.ok && /customer_posted=true/.test(r.url)) {
            showCode();
          } else {
            // CAPTCHA (or anything else) wants the native flow
            storageSet(KEY_PENDING, '1');
            form.submit();
          }
        })
        .catch(function () {
          storageSet(KEY_PENDING, '1');
          form.submit();
        })
        .finally(function () {
          btn.disabled = false;
        });
    });
  }

  var codeBtn = dialog.querySelector('[data-popup-copy]');
  if (codeBtn) {
    codeBtn.addEventListener('click', function () {
      var hint = dialog.querySelector('[data-popup-copy-hint]');
      function done() { hint.textContent = 'copied'; }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText('FIRSTTRACKS').then(done, done);
      } else {
        done();
      }
    });
  }

  if (/[?&]popup=force/.test(window.location.search)) {
    storageDel(KEY_DONE);
    storageDel(KEY_DISMISSED);
    setTimeout(openPopup, 400);
    return;
  }

  var posted = /[?&]customer_posted=true/.test(window.location.search);
  if (posted && storageGet(KEY_PENDING)) {
    storageDel(KEY_PENDING);
    showCode();
    openPopup();
    return;
  }

  if (!storageGet(KEY_DONE)) {
    var dismissed = parseInt(storageGet(KEY_DISMISSED) || '0', 10);
    if (!dismissed || Date.now() - dismissed >= DISMISS_DAYS * 864e5) {
      setTimeout(function waitForSplash() {
        if (document.querySelector('[data-campo-splash]')) {
          setTimeout(waitForSplash, 1000);
          return;
        }
        setTimeout(openPopup, 2500);
      }, SHOW_DELAY_MS);
    }
  }
})();
